/**
 * CartAnalyzeContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import CartAnalyzePresenter from './CartAnalyzePresenter';
import MessageAlert from 'utils';
import { CartApi, StatisticsApi } from 'api';
import dayjs from 'dayjs';
// import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 컨테이너
 * ----------------------------------------
 */
const CartAnalyzeContainer = ({ defaultShopId, permission }) => {
  /* ===== INIT ===== */
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [statisticsType, setStatisticsType] = useState('month');
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState({
    product: null,
    category: null,
    shop: null,
    rawData: null,
  });
  const [updatedAt, setUpdatedAt] = useState([]);
  const [userListModal, setUserListModal] = useState(null);
  const [userList, setUserList] = useState(null);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**
   * 카트목록 조회
   * --
   */
  const handleGetCartUserList = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await StatisticsApi.getStatistics(
        'cart_user',
        {
          productId: userListModal,
        }
      );
      if (status !== 200) throw { message };
      setUserList(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log('[CartAnalyzeContainer][handleGetCartUserList] Error: ', e);
      MessageAlert.error(e.message);
    }
  };
  /**
   * 카트목록 조회
   * --
   */
  const handleGetCartList = async (t = 'search') => {
    setLoading(true);
    try {
      const type = t.toLocaleUpperCase();
      const dd =
        type === 'SEARCH'
          ? statisticsType === 'today'
            ? 1
            : statisticsType === 'week'
            ? -7
            : statisticsType === 'month'
            ? -30
            : -90
          : -7;
      const { status, message, data } = await StatisticsApi.getStatistics(
        'cart',
        {
          startDate: dayjs().add(dd, 'days').startOf().format('YYYY-MM-DD'),
          endDate: dayjs().endOf().format('YYYY-MM-DD'),
          ...(defaultShopId && { shopId: currentShop }),
        }
      );
      if (status !== 200) throw { message };
      // Product ID별로 분류하여 저장
      const groupedByProductId = data.reduce((acc, item) => {
        if (!acc[item.product_id]) {
          acc[item.product_id] = {
            label: item.product_name,
            price: item.product_price,
            shop_information_name: item.shop_information_name,
            data: [],
          };
        }
        acc[item.product_id].data.push(item);
        return acc;
      }, {});

      // Category ID별로 분류하여 저장
      const groupedByCategoryId = data.reduce((acc, item) => {
        if (!acc[item.category_id]) {
          acc[item.category_id] = { label: item.category_name, data: [] };
        }
        acc[item.category_id].data.push(item);
        return acc;
      }, {});

      // Shop ID별로 분류하여 저장
      const groupedByShopId = data.reduce((acc, item) => {
        if (!acc[item.shop_information_id]) {
          acc[item.shop_information_id] = {
            label: item.shop_information_name,
            data: [],
          };
        }
        acc[item.shop_information_id].data.push(item);
        return acc;
      }, {});

      setTimeout(() => {
        setChartData({
          product: groupedByProductId,
          category: groupedByCategoryId,
          shop: groupedByShopId,
          rawData: data,
        });
        setLoading(false);
      }, 850);
    } catch (e) {
      setLoading(false);
      console.log('[CartAnalyzeContainer][handleGetCartList] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    handleGetCartList();
  }, []);
  /*  */
  useEffect(() => {
    handleGetCartList();
  }, [currentShop]);
  /*  */
  useEffect(() => {
    userListModal && handleGetCartUserList();
  }, [userListModal]);

  /* ===== RENDER ===== */
  const props = {
    loading,
    chartData,
    permission,
    statisticsType,
    setStatisticsType,
    handleGetCartList,
    userListModal,
    setUserListModal,
    userList,
  };
  // JSX: start
  return (
    <>
      <CartAnalyzePresenter {...props} />
    </>
  ); // JSX: end
};

CartAnalyzeContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default CartAnalyzeContainer;
